module.exports = __webpack_public_path__ + "16b5aaa3190beb16d590aeaa1c9b0cc5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/category_2.png
// module id = ./assets/images/category_2.png
// module chunks = 0